import { applySnapshot, flow, Instance, types } from 'mobx-state-tree';
import { Weather } from 'http-requests';
import { RequestStateModel } from './general-models';

export interface IWeatherData extends Instance<typeof WeatherDataModel> {}
export interface ITemperatureData
  extends Instance<typeof TemperatureDataModel> {}
export interface IWeatherParams {
  longitude: number;
  latitude: number;
  date?: string;
  date_till?: string;
  report_type?: string;
}

const StatusesModel = types.model('StatusesModel', {
  data: types.optional(RequestStateModel, {}),
});

const TemperatureDataModel = types.model('TemperatureDataModel', {
  time: types.optional(types.string, ''),
  temperature: types.optional(types.number, 0),
});

const WeatherDataModel = types.model('WeatherDataModel', {
  date: types.optional(types.string, ''),
  location: types.optional(types.string, ''),
  latitude: types.optional(types.number, 0),
  longitude: types.optional(types.number, 0),
  temperature: types.optional(types.number, 0),
  temperature_data: types.optional(types.array(TemperatureDataModel), []),
});

export const WeatherStore = types
  .model('WeatherStore', {
    statuses: types.optional(StatusesModel, {}),
    data: types.optional(types.array(WeatherDataModel), []),
  })
  .actions((self) => ({
    reset() {
      applySnapshot(self, {});
    },
    getWeather: flow(function* (data: IWeatherParams) {
      try {
        self.statuses.data.loadingStates();

        const response = yield Weather.GetWeather(data);
        self.data = response.weather_data.map((item: IWeatherData) =>
          WeatherDataModel.create(item)
        );
        self.statuses.data.successStates();

        return response;
      } catch (error) {
        self.statuses.data.errorStates();
      } finally {
        self.statuses.data.finallyStates();
      }
    }),
  }));
